import { ELIGIBILITY_STATUS } from '../api/dist026Api';

// experiment start date= 28th August @ 9:00 GMT
const EXPERIMENT_START_TIMESTAMP = 1693209600000;
export function inDist026Cohort({
  status,
  updatedAt
}) {
  return status === ELIGIBILITY_STATUS.ELIGIBLE && updatedAt && updatedAt > EXPERIMENT_START_TIMESTAMP;
}